import { Question,QuestionDiscussion } from '../../@types/question.interface';
import {
    QUESTIONS,
    QUESTION,
    QuestionActionType,
    CLEAR_QUESTIONS,
    CLEAR_QUESTION,
    QUESTIONS_DISCUSSION,
    CLEAR_QUESTION_DISCUSSION
} from './question.actions';

interface IState {
    question: Question | null;
    questions: Question[] | null;
    question_answer: QuestionDiscussion[] | null;
}

const INITIAL_STATE: IState = {
    question: null,
    questions: null,
    question_answer: null
};

export default function questionReducer(
    state: IState = INITIAL_STATE,
    action: QuestionActionType
): IState {
    switch (action.type) {
        case QUESTION:
            return {
                ...state,
                question: action.payload.question,
            };
        case QUESTIONS:
            return {
                ...state,
                questions: action.payload.questions,
            };
        case QUESTIONS_DISCUSSION:
            return {
                ...state,
                question_answer: action.payload.question_answer
            };
        case CLEAR_QUESTION_DISCUSSION:
            return {
                ...state,
                question_answer: null
            };
        case CLEAR_QUESTIONS:
            return {
                ...state,
                questions: null,
            };
        case CLEAR_QUESTION:
            return {
                ...state,
                question: null,
            };
        default:
            return state;
    }
}
